.cellHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
